var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_5683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.125 55.125V49.875C45.125 47.0902 44.0188 44.4195 42.0496 42.4504C40.0805 40.4812 37.4098 39.375 34.625 39.375H13.625C10.8402 39.375 8.16951 40.4812 6.20038 42.4504C4.23125 44.4195 3.125 47.0902 3.125 49.875V55.125",
    stroke: "#2C2C2C",
    strokeWidth: 5.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.125 28.875C29.924 28.875 34.625 24.174 34.625 18.375C34.625 12.576 29.924 7.875 24.125 7.875C18.326 7.875 13.625 12.576 13.625 18.375C13.625 24.174 18.326 28.875 24.125 28.875Z",
    stroke: "#2C2C2C",
    strokeWidth: 5.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.875 55.1246V49.8746C60.8733 47.5481 60.0989 45.2881 58.6736 43.4494C57.2482 41.6107 55.2526 40.2974 53 39.7158",
    stroke: "#2C2C2C",
    strokeWidth: 5.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 8.21582C44.7586 8.79411 46.7605 10.1077 48.1901 11.9494C49.6196 13.7911 50.3956 16.0562 50.3956 18.3877C50.3956 20.7191 49.6196 22.9843 48.1901 24.826C46.7605 26.6677 44.7586 27.9813 42.5 28.5596",
    stroke: "#2C2C2C",
    strokeWidth: 5.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_5683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1319497d908daee8fb4f42223bcd48cd.svg";
export { ForwardRef as ReactComponent };